import { render, staticRenderFns } from "./AddUserFrom.vue?vue&type=template&id=1b7e8876&scoped=true&"
import script from "./AddUserFrom.vue?vue&type=script&lang=js&"
export * from "./AddUserFrom.vue?vue&type=script&lang=js&"
import style0 from "./AddUserFrom.vue?vue&type=style&index=0&id=1b7e8876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e8876",
  null
  
)

export default component.exports